"use client"

import React, { forwardRef, MouseEventHandler } from "react"
import * as Toggle from "@radix-ui/react-toggle"

import { cn } from "@/lib/utils"

import { RemixIcon } from "../remix-icon/RemixIcon"

type TToggleMenuIconProps = {
  className?: string
  pressed: boolean
  onPressed?: (isOpen: boolean) => void
  onClick?: MouseEventHandler<HTMLButtonElement>
  title?: string
}

const ToggleMenuIcon = forwardRef<
  React.ElementRef<typeof Toggle.Root>,
  React.ComponentPropsWithoutRef<typeof Toggle.Root> & TToggleMenuIconProps
>(({ className, pressed, onPressed, onClick, title, ...props }, ref) => {
  const animationRotationClasses = pressed
    ? "-rotate-180 ease-in duration-200"
    : "rotate-0 opacity-1 ease-out duration-300"

  return (
    <Toggle.Root
      {...props}
      ref={ref}
      aria-label={`Menu ${pressed ? "Close" : "Open"}`}
      pressed={pressed}
      onPressedChange={onPressed}
      onClick={onClick}
      className={cn(
        "flex size-6 place-content-center items-center justify-between border-0 bg-transparent text-current focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-current focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
        className
      )}
    >
      <span className="main-navigation__link">{title}</span>
      <RemixIcon
        name="ArrowDownS"
        size="md"
        className={cn("fill-dark", animationRotationClasses)}
      />
    </Toggle.Root>
  )
})
ToggleMenuIcon.displayName = "ToggleMenuIcon"

export { ToggleMenuIcon, type TToggleMenuIconProps }
